import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { baseurl } from "../Baseurl";

const PaypalPaymentGateway = () => {
  const { state } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!state) {
      navigate("/");
      return;
    }

    const initiatePaypal = async () => {
      try {
        const res = await axios.post(
          `${baseurl}initiatePaypalPayment`,
          {
            user_id: state.user_id,
            shipping_address_id: state.shipping_address_id,
            coupon_id: state.coupon || "null",
            discount: state.discount || 0,
            note: state.note || "",
            cartItems: state.cartItems,
            payment_method: state.payment_method,
            grand_total: state.grand_total,
          }
        );

        if (res.data.success && res.data.paypal?.approval_url) {
          // 🔥 Redirect to PayPal
          window.location.href = res.data.paypal.approval_url;
        } else {
          alert("Failed to initiate PayPal payment");
        }

      } catch (error) {
        console.error("PayPal initiation error:", error);
        alert("Something went wrong with PayPal payment");
      }
    };

    initiatePaypal();
  }, [state, navigate]);

  return (
    <div className="container text-center mt-5">
      <h4>Redirecting to PayPal…</h4>
      <p>Please wait while we connect you to PayPal</p>
    </div>
  );
};

export default PaypalPaymentGateway;
